import React, { useState, useEffect } from 'react';
import { createUser, fetchRecentUsers, fetchAllUsers } from '../../api/userApi'; // Adjust the import path as needed

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [newUser, setNewUser] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '', // Assuming you have a password field
        is_verified: false,
        preferred_contact_method: 'email'
    });

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const recentUsers = await fetchAllUsers();
            setUsers(recentUsers);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewUser({ ...newUser, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const createdUser = await createUser(newUser);
            setUsers([createdUser, ...users.slice(0, 9)]); // Add new user to the top and keep only 10 users
            setNewUser({
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                password: '',
                is_verified: false,
                preferred_contact_method: 'email'
            });
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    return (
        <div>
            <h2>User Management</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>First Name:</label>
                    <input type="text" name="first_name" value={newUser.first_name} onChange={handleChange} required />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input type="text" name="last_name" value={newUser.last_name} onChange={handleChange} required />
                </div>
                <div>
                    <label>Email:</label>
                    <input type="email" name="email" value={newUser.email} onChange={handleChange} required />
                </div>
                <div>
                    <label>Phone:</label>
                    <input type="text" name="phone_number" value={newUser.phone_number} onChange={handleChange} required />
                </div>
                <div>
                    <label>Password:</label>
                    <input type="password" name="password" value={newUser.password} onChange={handleChange} required />
                </div>
                <div>
                    <label>Preferred Contact Method:</label>
                    <select name="preferred_contact_method" value={newUser.preferred_contact_method} onChange={handleChange}>
                        <option value="email">Email</option>
                        <option value="call">Call</option>
                        <option value="text">Text</option>
                    </select>
                </div>
                <button type="submit">Create User</button>
            </form>
            <h3>10 Most Recently Created Users</h3>
            <ul>
                {users.map(user => (
                    <li key={user.id}>{user.first_name} {user.last_name} - {user.email}</li>
                ))}
            </ul>
        </div>
    );
};

export default UserManagement;
